// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { addToChainAfter, replaceInChain } from "@insite/client-framework/HandlerCreator";
import { getCartState, getCurrentCartState } from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import {
    chain,
    DispatchCompletePlaceOrder,
    SetCartStatus,
} from "@insite/client-framework/Store/Pages/CheckoutReviewAndSubmit/Handlers/PlaceOrder";
import { CustomAppState } from "@tps/App/Store/Reducers";
import cloneDeep from "lodash/cloneDeep";

export const TpsSetCartStatus: any = (props: any) => {
    const state = props.getState();
    const { cartId } = state.pages.checkoutReviewAndSubmit;
    const cart = cartId ? getCartState(state, cartId).value : getCurrentCartState(state).value;

    if (!cart) {
        throw new Error("There was no current cart and we are trying to place the current cart as an order.");
    }

    const newStatus = cart?.requiresApproval
        ? "AwaitingApproval"
        : props.parameter?.isPending
        ? "PendingPaymentValidation"
        : "Submitted";

    props.cartToUpdate = {
        ...cloneDeep(cart),
        status: newStatus,
        poNumber: props.parameter.poNumber,
        customerVatNumber: props.parameter.vatNumber || "",
        // XNG-Change
        notes: (state as CustomAppState)?.xCheckout?.notes || "",
        properties: {
            ...cart.properties,
            isRequireMtr: (state as CustomAppState)?.xCheckout?.requiresMtr?.toString() || "false",
            saveOneTimeAddress: (state as CustomAppState)?.xCheckout?.saveOneTimeAddress?.toString() || "false",
        },
    };
};

// XNG-Change
export const DispatchResetStates: any = (props: any) => {
    props.dispatch({
        type: "xShippingDetails/ResetAllShippingDetails",
    } as any);
    props.dispatch({
        type: "xCheckout/Reset",
    } as any);
};

replaceInChain(chain, SetCartStatus, TpsSetCartStatus);
addToChainAfter(chain, DispatchCompletePlaceOrder, DispatchResetStates);
